import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { CellQuarterly } from './cell-quarterly';
import { filterActiveMetrics, orderMetrics } from './header-semi-annually';
interface HeaderQuarterlyProps {
  title: string;
  className?: string;
  headerTable: MetricValues[];
  activeMetrics: string[];
  year: string;
}
function HeaderQuarterly(t0) {
  const $ = _c(19);
  const {
    title,
    className,
    headerTable,
    year,
    activeMetrics
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 2, 3, 4];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== year) {
    t2 = [...(t1 as const).map(quarter => `Q${quarter} ${year}`), "Total"];
    $[1] = year;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const keysMetrics = t2;
  let t3;
  if ($[3] !== activeMetrics || $[4] !== headerTable) {
    t3 = filterActiveMetrics(activeMetrics, headerTable);
    $[3] = activeMetrics;
    $[4] = headerTable;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const metricsActive = t3;
  let t4;
  if ($[6] !== className) {
    t4 = cn("flex min-h-[83px] flex-1 items-center justify-start overflow-hidden rounded-xl whitespace-pre", "bg-muted shadow-sm", "[&::-webkit-scrollbar]:h-0 [&::-webkit-scrollbar]:w-0", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("border-border flex min-h-12 w-[145px] flex-row items-center justify-start border-r p-4 pr-2", "lg:w-[148px] lg:pl-2", "xl:w-[220px] xl:px-8", "2xl:w-[260px] 2xl:px-8 2xl:pr-2", "3xl:w-[228px] 3xl:px-4");
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== title) {
    t6 = <div className={t5}><div className="text-foreground max-w-full pr-2 text-base leading-normal font-semibold wrap-break-word xl:font-bold xl:whitespace-normal">{title}</div></div>;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== activeMetrics || $[12] !== keysMetrics || $[13] !== metricsActive) {
    t7 = <div className="flex flex-1 flex-row items-center">{keysMetrics.map((quarterly, index) => <CellQuarterly key={quarterly} metrics={metricsActive[index] ?? {}} quarterly={quarterly} activeMetrics={orderMetrics(undefined, activeMetrics)} isTotal={quarterly === "Total"} />)}</div>;
    $[11] = activeMetrics;
    $[12] = keysMetrics;
    $[13] = metricsActive;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export { HeaderQuarterly };